import React, { useState } from 'react';
import ArrowLinkButton from '../buttons/arrowLinkButton';
import { PromoProductBtn } from '../cms/buttonText.constants';
import Colors from '../colors/colors';
import IgniteFlashMessage from '../flashMessage/IgniteFlashMessage';
import type { Promotion } from '../../containers/products/products.reducer';
import type { FlashMessageVariantType } from '../flashMessage/flashMessage.constants';
import IgniteModal, { IgniteModalContent } from '../modal/igniteModal';

type PromoProductFlashMessageProps = {
  promotion: Promotion;
  promoMessage?: string;
  hasFundByDatePassed?: boolean;
  variant?: FlashMessageVariantType;
};

export const PromoProductFlashMessage = React.memo<PromoProductFlashMessageProps>(
  ({ promotion, promoMessage, hasFundByDatePassed, variant }) => {
    const [showPromoModal, setShowPromoModal] = useState(false);
    return (
      <>
        <IgniteFlashMessage data-test="promo-product-message" variant={variant}>
          {!promoMessage ? promotion.promotionDescription : promoMessage}{' '}
          {!hasFundByDatePassed ? (
            <ArrowLinkButton
              textColor={Colors.charcoalGrey}
              onClick={() => setShowPromoModal(true)}
              buttonText={PromoProductBtn.PROMO_DETAILS}
            />
          ) : null}
        </IgniteFlashMessage>
        <IgniteModal
          title={PromoProductBtn.PROMO_DETAILS}
          visible={showPromoModal}
          data-test="promo-details-modal"
          showCloseX
          onClose={() => setShowPromoModal(false)}
        >
          <IgniteModalContent variant="text">{promotion.promotionDisclosure}</IgniteModalContent>
        </IgniteModal>
      </>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.promotion.promotionName === nextProps.promotion.promotionName;
  }
);

export default PromoProductFlashMessage;
